export type BrokerId = 'trading212' | 'custom';

export interface BrokerGuideSection {
    heading?: string;
    steps: string[];
}

export interface BrokerGuide {
    id: BrokerId;
    name: string;
    accepts: string[];
    title: string;
    sections: BrokerGuideSection[];
    notes?: string[];
    helpUrl?: string;
    ctaLabel: string;
}

const recurringImportNote =
    'Later, export only the new date range since your last import and upload again via Import.';

export const brokerImportGuides: Record<BrokerId, BrokerGuide> = {
    trading212: {
        id: 'trading212',
        name: 'Trading 212',
        accepts: ['.csv'],
        title: 'How to export your trading data from Trading 212',
        sections: [
            {
                heading: 'Web (desktop)',
                steps: [
                    'Press your email address (top-right).',
                    'Go to History.',
                    'Select the Export icon.',
                    'Pick the timeframe and data to include.',
                    'Confirm and download the CSV.',
                ],
            },
            {
                heading: 'Mobile',
                steps: [
                    'Open your Invest or ISA account (not CFD).',
                    'Go to History.',
                    'Tap Export (top-right).',
                    'Select timeframe (max 1 calendar year per report).',
                    'Choose what data to include, then submit and download the CSV when ready.',
                ],
            },
        ],
        notes: [
            'Export is not available for CFD accounts.',
            'For multiple years, export multiple files (one per calendar year).',
            recurringImportNote,
        ],
        helpUrl: 'https://helpcentre.trading212.com/',
        ctaLabel: 'Upload Trading 212 CSV',
    },
    custom: {
        id: 'custom',
        name: 'Other brokers',
        accepts: ['.csv', '.xls', '.xlsx'],
        title: 'Import from other brokers (beta)',
        sections: [
            {
                steps: [
                    'Export your transactions from your broker as CSV/XLS/XLSX.',
                    'Upload the file here and we will auto-detect column mappings.',
                    'Review any warnings and complete the import.',
                ],
            },
        ],
        notes: [
            'Trading 212 currently has the best native import support.',
            'Other broker imports use our generic parser and may need review for some rows.',
            recurringImportNote,
        ],
        ctaLabel: 'Upload file',
    },
};

export const brokerGuideOrder: BrokerId[] = ['trading212', 'custom'];
